import React from "react"

import Header from "components/Header"
import AppPromo from "components/AppPromo"
import SearchHistory from "components/SearchHistory"
import Footer from "components/Footer"

import "./Landing.sass"
import { useNavigate } from "react-router-dom"
import { isReactEnvironment } from "utils"

const EXAMPLE_NUMBER = "5N3ZA0NE6AN906847"

const Landing = () => {
  const navigate = useNavigate()
  function redirect(to) {
    if (isReactEnvironment) {
      navigate(to)
    } else {
      window.location.pathname = to
    }
  }

  const handleChartClick = (e) => {
    e.preventDefault()
    redirect(`/search/${EXAMPLE_NUMBER}`)
  }
  return (
    <>
      <div id="header-root" className="isTall">
        <Header isCentered isTall />
      </div>

      <div className="Landing">
        <div className="info-content">
          <div className="example card-container">
            <h3>Naključno izbrano vozilo</h3>
            <a href={`/search/${EXAMPLE_NUMBER}`} onClick={handleChartClick}>
              <h4 id="random-name">
                <span>SEAT IBIZA / 1.0</span>
                <span className="vin">5N3ZA0NE6AN906847</span>
              </h4>
              <img
                className="chart"
                src="/placeholders/Chart - Kilometers Large.svg"
                alt="Prevoženi kilometri"
              />
            </a>
          </div>

          <AppPromo />
        </div>

        <div className="history-content">
          <SearchHistory />
        </div>
      </div>

      <Footer />
    </>
  )
}

export default Landing
